import React from 'react';
import { connect } from 'react-redux';

import * as actions from '../../action/shop-home/shop-home';
import ShopDetail from '../../component/shop-home/shop-detail';
import ShopSwiper from '../../component/shop-home/shop-swiper';
import MenuList from '../../component/shop-home/menu-list';
import ShopCard from '../../component/shop-home/shop-card';
import Toast from '../../component/mui/toast';
import commonHelper from '../../helper/common-helper';
import { initWXShareEventWithConfig } from '../../helper/wx-share-config';
import { WxSharEventEntry } from '../../helper/const';
import MessageDialog from '../../component/mui/dialog/message-dialog';
import HealthIcon from '../../component/health-icon';
import Loading from '../../component/mui/loading';

import shopMessages from '../../intl/messages/shop';
import buttonMessages from '../../intl/messages/button';
import { formatMessage } from '../../intl/helper';
import FormattedMessage from '@/intl/formatted-message';
import containnerText1 from '../../intl/messages/container/part1';

import shopCloseImg from '../../asset/images/yidayang.svg';
import '../../asset/style/style.scss';

const isWeiXinMiniBrowser = commonHelper.isWechatMiniProgramBrowser();

class ShopHomeApplication extends React.Component {
  componentWillMount() {
    sessionStorage.removeItem('lastTableInfo');
    localStorage.removeItem('basicListInfo');
    this.props.fetchUserInfo();

    const { setErrorMsg } = this.props;
    commonHelper.getCommericalInfo(setErrorMsg, commericalInfo => {
      if (!commericalInfo.enablePortalStore) {
        setErrorMsg({
          text: formatMessage(containnerText1.OrderInlineApplicationoccluedMobileShop),
          timeout: -1,
        });
      }
    });
  }
  componentDidMount() {
    const { fetchShopDetail, fetchServiceCard, fetchShopInfo } = this.props;
    fetchShopDetail()
      .then(() => fetchShopInfo())
      .then(fetchServiceCard);
  }

  componentDidUpdate() {
    initWXShareEventWithConfig({ entry: WxSharEventEntry.SHOP, _this: this });
  }

  render() {
    const { fetchShopDetail, getCheckQueue, setSocketCardData, setToastProps, shopInfo, setLoading, setErrorMsg, loading } = this.props;
    const { shopIntroImgs, shopDetail, serviceCardVO, menuList, userInfo, socketCardData, toastProps, activeSocketCard, errorMessage } = this.props;
    return (
      <div className="o-bg-grey o-credit">
        <ShopCard
          fetchShopDetail={fetchShopDetail}
          shopDetail={shopDetail}
          userInfo={userInfo}
          serviceCardVO={serviceCardVO}
          setSocketCardData={setSocketCardData}
          socketCardData={socketCardData}
          activeSocketCard={activeSocketCard}
          setToastProps={setToastProps}
          toastProps={toastProps}
          enableSyncShoppingCart={shopInfo ? shopInfo.enableSyncShoppingCart : 1}
        />
        <ShopSwiper shopIntroImgs={shopIntroImgs} />
        <div className="o-mb" />
        <MenuList menuList={menuList} getCheckQueue={getCheckQueue} shopDetail={shopDetail} memberVO={serviceCardVO.memberVO} />
        <div className="o-mb" />
        <ShopDetail shopDetail={shopDetail} setLoading={setLoading} />
        {errorMessage.text && <Toast clearErrorMsg={this.props.clearErrorMsg} errorMessage={errorMessage.text} timeout={errorMessage.timeout} />}
        {loading && <Loading word={loading} />}
        {shopInfo && !shopInfo.enableWeixinMini && !!isWeiXinMiniBrowser && (
          <div className="dish-mesthead-opendialog">
            <MessageDialog onConfirm={() => {}} btnText={<span className="shopopen-btn_disabled">{formatMessage(buttonMessages.iknown)}</span>}>
              <img className="shopopen-img" src={shopCloseImg} alt={formatMessage(shopMessages.closedFlag)} />
              <p className="shopopen-info">
                <FormattedMessage {...shopMessages.isClose} />
              </p>
              <div className="shopopen-time">
                <FormattedMessage {...containnerText1.DishMenuApplicationmircAppUnOpen} />
              </div>
            </MessageDialog>
          </div>
        )}

        <HealthIcon />
      </div>
    );
  }
}

ShopHomeApplication.propTypes = {
  fetchShopDetail: React.PropTypes.func,
  fetchServiceCard: React.PropTypes.func,
  setSocketCardData: React.PropTypes.func,
  getCheckQueue: React.PropTypes.func,
  shopDetail: React.PropTypes.object,
  shopIntroImgs: React.PropTypes.array,
  menuList: React.PropTypes.array,
  clearErrorMsg: React.PropTypes.func,
  errorMessage: React.PropTypes.object,
  fetchUserInfo: React.PropTypes.func,
  userInfo: React.PropTypes.object,
  serviceCardVO: React.PropTypes.object,
  socketCardData: React.PropTypes.array,
  activeSocketCard: React.PropTypes.bool,
  setToastProps: React.PropTypes.func,
  toastProps: React.PropTypes.object,
  setErrorMsg: React.PropTypes.func,
  fetchShopInfo: React.PropTypes.func,
  setLoading: React.PropTypes.func,
  loading: React.PropTypes.string,
};

export default connect(
  state => state,
  actions,
)(ShopHomeApplication);



// WEBPACK FOOTER //
// ./src/container/shop-home/application.jsx